import { ActivityApiModel } from '@app/api/api-models/activities';
import { FormInstancePerformanceCategoryHeadingApiModel } from '../program/shared/form-instances/FormInstancePerformanceCategoryHeadingApiModel';
import { BindedPerformanceCategoryApiModel } from './BindedPerformanceCategoryApiModel';

export class BindedFormInstanceApiModel {
  public Id: number;
  public Name: string;
  public WorkDate: Date;
  public CompletedOn: Date;
  public CurrentStepName: string;
  public CurrentStepId: number;
  public Hours: number;
  public Location: string;
  public LocationId: number;
  public Shift: string;
  public ShiftId: number;
  public Trainer: string;
  public TrainerId: string;
  public InstanceNumber: string;
  public HoursTracking: boolean;
  public IsNotObserved: boolean;
  public IsViewable: boolean;
  public Completions: Array<ActivityApiModel>;
  public PerformanceCategories: Array<BindedPerformanceCategoryApiModel>;
  public PerformanceCategoryHeadings: Array<FormInstancePerformanceCategoryHeadingApiModel>;
  public IsChecked?: boolean;

  public deserialize(data: Object): BindedFormInstanceApiModel {
    Object.assign(this, data);

    this.WorkDate = new Date(this.WorkDate);

    this.Completions = this.Completions && this.Completions.map((x) => new ActivityApiModel().deserialize(x));

    return this;
  }
}
